import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {BrandHeader} from "./giftcard-home-comps";
import QRCode from "react-qr-code";
import "./giftcard-home.css";
import "./app-download.css";
import API from "../api";

const AppDownload = () => {
    console.log( "rendering AppDownload" );
    const { t, i18n } = useTranslation();
    const brandHeaderRef = useRef(null);
    const [appUrls, setAppUrls] = useState({});
    
    const getClientPlatform = () => {
        const ua = navigator.userAgent || window.opera;
        console.log( "UA:", navigator.userAgent );

        if ( /android/i.test( ua ) ) {
            return "android";
        } else if (
            /iPad|iPhone|iPod/.test( ua ) ||
            (navigator.userAgentData && navigator.userAgentData.platform === 'iOS')
        ) {
            return "ios";
        } else {
            return "other";
        }
    };
    
    // Initialize platform immediately to prevent flash of wrong content
    const [platform, setPlatform] = useState(() => {
        const detectedPlatform = getClientPlatform();
        console.log( "Client platform detected as:", detectedPlatform );
        return detectedPlatform;
    });
    const  api = API();


    const loadConfig = async () => {
        const clientConfig = await api.getClientConfig();
        console.log(clientConfig);
        setAppUrls(clientConfig.app_store_url || {});
        // Platform is already set during initialization, no need to set it again
    };

    useEffect( () => {
        loadConfig();
    }, [] );

    return <div className={"main"}>
        <BrandHeader className="large" ref={brandHeaderRef}/>
        <div className="buttonGroup">
            <a className={`button matches-client-platform-${platform == 'android'}`}
               href={appUrls.android || ''}
               rel="noopener noreferrer"
            >
                {t( "giftcard.getItOnGooglePlay" )}
            </a>
            <a className={`button matches-client-platform-${platform == 'ios'}`}
               href={appUrls.ios || ''}
               rel="noopener noreferrer">
                {t( "giftcard.getItOnTheAppStore" )}
            </a>
        </div>
        <div className={`matches-client-platform-${platform == 'other'}`}>
            {t( "giftcard.onlyMobileDevicesInfo" )}
            <div className="qrCodeContainer">
                <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={window.location.href}
                    viewBox={`0 0 256 256`}
                />
            </div>
        </div>

        <div className={`matches-client-platform-${platform != 'other'}`}>
            {t( "giftcard.appDownloadInfo" )}
        </div>
    </div>;
}

export default AppDownload
